import getArrQuery from './getArrQuery'
import C from '../constants'

const formatAuctionQueryUrl = (
  baseUrl: string,
  category: string,
  pageId: number,
  optional?: {
    searchInput?: string
    pastAuction?: boolean
    isMnr?: boolean
    isCategory?: boolean
    isPalletLot?: boolean
    location?: number[] | number
    pickupDate?: string[] | string | undefined
  },
  endpoint = 'getAuctions'
) => {
  const {
    searchInput = '',
    pastAuction = false,
    isMnr = false,
    isPalletLot = false,
    location = [],
    pickupDate = [],
  } = optional || {}

  const route = `/auction/${endpoint}${
    baseUrl.includes('/location') ? baseUrl.split('/').pop() : ''
  }`

  const query: any = {
    pageId,
    pastAuction,
  }

  if (!isPalletLot) {
    query.categories =
      category === 'all' ? 'Categories - All' : category.replace(/-/g, ' ')
  } else {
    query.palletAuction = true
  }

  if (query?.categories === 'members only') {
    query.auctionTypeId = C.MEMBERS_ONLY_TYPE_ID
    delete query.categories
  }

  if (isMnr) {
    query.isMnr = isMnr
  }

  if (searchInput) {
    if (pastAuction) {
      query.auctionNumber = searchInput
    } else {
      query.searchKeywords = searchInput
    }
  }

  const pickupDateQuery = getArrQuery(pickupDate)
  const locationQuery = getArrQuery(location)

  if (pickupDateQuery.length) {
    query.pickupDates = pickupDateQuery
  }
  if (locationQuery.length) {
    query.selectedLocationIds = locationQuery.join(',')
  }

  return { url: route, query }
}

export default formatAuctionQueryUrl
